import Tab from 'bootstrap/js/dist/tab';

export default class CustomTab {
    constructor(el) {
        this.DOM = { el: el };
        this.target = this.DOM.el.dataset.tabTarget;
        this.groupTarget = this.DOM.el.dataset.target ? this.DOM.el.dataset.target : null;
        this.initEvents();
    }

    initEvents() {
        this.DOM.el.addEventListener('click', () => {
            const targetElement = document.querySelector(this.target);

            if (this.groupTarget) {
                const groupTargetEl = document.querySelector(this.groupTarget);
                const groupTargetChildren = groupTargetEl.querySelectorAll('.tab-pane');
                if (groupTargetChildren) {
                    groupTargetChildren.forEach(child => {
                        if (child !== targetElement) {
                            child.classList.remove('active');
                            child.classList.remove('show');
                        }
                    })
                }
            }

            if (targetElement) {
                const tabTrigger = new Tab(targetElement);
                tabTrigger.show();
            }
        });
    }
}

class CustomTabToggle {
    constructor(el) {
        this.el = el;
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener('click', (event) => {
            event.preventDefault();
            const targetId = this.el.getAttribute('href');
            const targetEl = targetId ? document.querySelector(targetId) : null;
            if (!targetEl) return;

            const tablist = this.el.closest('[role="tablist"]');
            const panesContainer = targetEl.parentElement;

            panesContainer.querySelectorAll('.custom-tab-content').forEach(pane => {
                pane.classList.remove('active');
            });

            tablist?.querySelectorAll('.custom-tab').forEach(tab => {
                tab.classList.remove('active-tab');
                tab.setAttribute('aria-selected', 'false');
            });

            this.el.classList.add('active-tab');
            this.el.setAttribute('aria-selected', 'true');
            targetEl.classList.add('active');
        });
    }
}

const tabTargetNodes = Array.from(document.querySelectorAll('[data-tab-target]'));
tabTargetNodes.forEach((node) => { new CustomTab(node); });

const customTabNodes = Array.from(document.querySelectorAll('.custom-tab:not([data-tab-target])'));
customTabNodes.forEach((node) => { new CustomTabToggle(node); });
